module.exports = __webpack_public_path__ + "img/thumbnail_BengalTiger_m_albino.7206fc7f.png";